import React, { FC } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { JSONForm } from '../../../components/json-form/JSONForm';
import { Surcharge } from '../../../models';
import { useTranslation } from '../../../translations';
import { SurchargeForm } from './SurchargeForm';

interface Props {
  readonly open?: boolean;
  readonly onUpdate: (id: number) => void;
  readonly onCancel: () => void;
}

export const CreateModal: FC<Props> = ({ open, onCancel, onUpdate }) => {
  const { ts } = useTranslation();
  return (
    <Modal id="createSurchargeModal" isOpen={open}>
      <JSONForm<{ surcharge: Surcharge }, { amount: number }>
        id="createSurchargeForm"
        method="post"
        onSuccess={({ surcharge }) => {
          onUpdate(surcharge.id);
        }}
        path="/api/surcharges"
        preSubmit={(r) => (r.inputs.amount *= 100)}
      >
        <ModalHeader>{ts('create_surcharge')}</ModalHeader>
        <ModalBody>
          <SurchargeForm />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" id="createSurcharge">
            {ts('create_surcharge')}
          </Button>
          <Button color="secondary" onClick={onCancel}>
            {ts('common.cancel')}
          </Button>
        </ModalFooter>
      </JSONForm>
    </Modal>
  );
};
